import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { TranslateService } from '@ngx-translate/core';

import { IonBackButtonDelegate } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { BankAccountService } from '../../angular-wallet-base/services/bank-account.service';
import { MembersPortalService } from '../../angular-wallet-base/services/members-portal.service';
import { Logger } from '../../angular-wallet-base/services/logger.service';

@Component({
  selector: 'ach-modal-agreement',
  templateUrl: './ach-agreement-modal.html',
  styleUrls: ['./ach-agreement-modal.scss'],
})
export class AchAgreementModalComponent extends SubscriptionListenerComponent implements OnInit {

  @ViewChild(IonBackButtonDelegate) backButton: IonBackButtonDelegate;
  @Input() public agreementData;
  public enableAgreeButton: boolean = false;
  @ViewChild("achContainer", { static: false }) set content(content: ElementRef) {
    if (content) {
      content.nativeElement.onscroll = (e) => {
        const tosEl = e.target;
        const scrollTop = tosEl.scrollTop;
        const offSetHeight = tosEl.offsetHeight;
        const scrollHeight = tosEl.scrollHeight;

        if (scrollTop === 0) {
          this.enableAgreeButton = false;
        }
        if (scrollTop >= scrollHeight - offSetHeight - 1) {
          this.enableAgreeButton = true;
        }
      };
    }
  }
  agreementScroll;

  public agreements: any = [];
  public tosStatus: any = [];
  public actPatriot: any = [];

  stepTwoAccepted = false;

  step = 0;

  title = ["Review Patriot Act", "Review Terms of Service", "Direct Banking User Agreement"];

  constructor(
    protected store: Store<AppState>,
    private nav: NavController,
    private modal: ModalController,
    private bankAccountService: BankAccountService,
    private membersPortalService: MembersPortalService
  ) {
    super(store);
  }

  async ngOnInit() {
    if (!this.agreements.length) {
      this.agreements = await this.membersPortalService.getAgreedToTos();
      Logger.info("this.agreements ", this.agreements);
    }
    if (!this.tosStatus.length) {
      this.tosStatus = await this.membersPortalService.getTosAndStatus();
      Logger.info("this.tosStatus ", this.tosStatus);
    }
    if (!this.actPatriot.length) {
      this.actPatriot = await this.membersPortalService.getActPatriotText();
      Logger.info("this.actPatriot ", this.actPatriot);
    }
  }
  onDecline() {
    return this.modal.dismiss();
  }
  async onAgree() {
    try {
      await this.bankAccountService.createCustodialAccount();
      this.bankAccountService.setServiceStatusInStore("bankAccount", true);
      return this.modal.dismiss().then((success) => {
        return this.nav.navigateBack("prime-intro");
      });
    } catch (e) {
      return this.modal.dismiss();
    }
  }

  closeComponent() {
    this.stepTwoAccepted = true;
  }

  nextStep() {
    switch (this.step) {
      case 0:
        this.step = this.step + 1;
        break;

      case 1:
        this.step = this.step + 1;
        break;
      default:
        break;
    }
  }
}
